import { Mask } from './Mask';
import { Player } from '../game/Player';

export class PoseidonMask extends Mask {
  constructor(player: Player) {
    super(
      'Mask of Poseidon',
      'Breathe underwater and walk on water',
      0x00bcd4, // Cyan/Teal
      player
    );
    
    // Poseidon mask has passive abilities, no active ability needed
    this.maxAbilityDuration = 0;
    this.cooldownTime = 0;
  }
  
  protected onActivate(): void {
    // Enable water breathing
    this.player.canBreatheUnderwater = true;
  }
  
  protected onDeactivate(): void {
    // Disable water breathing
    this.player.canBreatheUnderwater = false;
  }
  
  protected onUpdate(_deltaTime: number): void {
    // Could add bubble particle effects here
  }
  
  protected onAbilityStart(): void {
    // No active ability
  }
  
  protected onAbilityEnd(): void {
    // No active ability
  }
  
  public useAbility(): boolean {
    // Poseidon mask is passive - show hint instead
    return false;
  }
}
